export default function Tecnologia() {
  return (
    <div id="container" style={{ paddingTop: '10em', paddingLeft: '2em' }}>
      <img src="images/mainengine_2015_logo_comprido.jpg"
        style={{ position: 'relative', left: '4px', width: '692px', height: 'auto', zIndex: 1, textAlign: 'left' }} />
      <div id="wb_Text8" style={{ position: 'relative', left: '4px', top: '7px', width: '143px', height: '27px', zIndex: 0, textAlign: 'left' }}>
        <div id="wb_Text10" style={{ position: 'relative', left: '2px', width: '717px', height: '74px', zIndex: 1, textAlign: 'left' }}>
          <h2 className="titulo2">Tecnologia</h2>
          <hr id="Line10" />
          <br />
          <div><span className="linha_texto">. Nossos sistemas operam na plataforma WEB, múltiplas camadas e processamentos remotos por TCP/IP</span></div>
          <div><span className="linha_texto">. Net Framework 8.0 </span></div>
          <div><span className="linha_texto">. NodeJs 18 </span></div>
          <div><span className="linha_texto">. Web Services, WEB-API, SOAP</span></div>
          <div><span className="linha_texto">. JSON, JWT, XML</span></div>
          <div><span className="linha_texto">. SQL Server, Postgresql.</span></div>
          <div><span className="linha_texto">. Javascript, React.Js, Electron</span></div>
        </div>
      </div>
    </div>
  )
}
